/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Show_Event_AriaInputs */



/**
* | output |
* | --- |
* | "Show Event Shortcut" |
*
* @param {Timing_Sync_Show_Event_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_show_event_aria = /** @type {((inputs?: Timing_Sync_Show_Event_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Show_Event_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Raccourci afficher l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfung zum Show-Event")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra collegamento evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать ярлык события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar acceso directo al evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示活动快捷方式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのショートカットを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट शॉर्टकट दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atalho para Mostrar Evento")
	return /** @type {LocalizedString} */ ("Show Event Shortcut")
});